import {Component, OnInit} from '@angular/core';
import {PromotionsFeaturedComponent} from "../../promotions-featured/promotions-featured.component";
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import {RouterLink} from "@angular/router";
import {GET_PROMOTIONS_FEATURED} from "../../../graphql/graphql.queris";
import {Apollo} from "apollo-angular";
import {environment} from "../../../../environments/environment";
import {convertirPrimeraLetraMayuscula} from "../../../utils/utilities";

@Component({
  selector: 'app-promociones-terapia-fisica',
  standalone: true,
  imports: [
    PromotionsFeaturedComponent,
  NgForOf,
  NgIf,
  RouterLink,
  NgStyle
  ],
  templateUrl: '../../promotions-featured/promotions-featured.component.html',
  styleUrl: '../../promotions-person/promotions-list/promotions-list.component.css'
})
export class PromocionesTerapiaFisicaComponent implements OnInit{
  promotions: any[] = [];
  promotionsVisibles: any[] = [];
  serverImgenUrl =environment.imgUrl;



  constructor(
    private apollo: Apollo,
  ) {
  }

  ngOnInit() {
    this.apollo
      .watchQuery({
        query: GET_PROMOTIONS_FEATURED,
        variables: {limit: 3, especialidad: 'Terapia Física'},
        fetchPolicy: 'no-cache'
      })
      .valueChanges.subscribe((result: any) => {
      this.promotions = result.data.getPromotionsFeatured
        .flat();
      // console.log(this.promotions);
      this.promotionsVisibles = this.promotions;

    });

  }
  protected readonly convertirPrimeraLetraMayuscula = convertirPrimeraLetraMayuscula

}
